import {Button, Center, createListCollection, Field, Input, Select, Show, Stack} from "@chakra-ui/react";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useRecoilState} from "recoil";
import {userData} from "../../components/hooks/recoilData";
import {useToast} from "@chakra-ui/toast";
import {dataApi} from "../../api/data-api";
import {errorNotify} from "../../components/hooks/CommonUtils";

interface WithdrawExt {
    type: string,
    spbTel: string,
    spbTelBankId: string,
    cardNumber: string,
    accountNumber: string,
    bic: string,
}

export const withdrawTypeList = createListCollection({
    items: [
        {label: "Bank account", value: "ACC"},
        {label: "Card", value: "CARD"},
        {label: "Phone", value: "TEL"},
    ],
});

export const Withdraw = () => {
    const inputDefault: WithdrawExt = useMemo(() => {
        return {
            type: "TEL",
            spbTel: "",
            spbTelBankId: "",
            cardNumber: "",
            accountNumber: "",
            bic: "",
        }
    }, []);
    const [inputParams, setInputParams] = useState<WithdrawExt>(inputDefault);
    const toast = useToast();
    const [user] = useRecoilState(userData);
    useEffect(() => {
        if (user) {
            dataApi.withdrawOwnGet()
                .then(o => {
                    setInputParams({
                        type: o.TYPE1,
                        spbTel: o.SPB_TEL.trim(),
                        spbTelBankId: String(o.SPB_TEL_BANK_ID),
                        cardNumber: o.CARD_NUMBER.trim(),
                        accountNumber: o.ACCOUNT_NUMBER.trim(),
                        bic: o.BIC.trim(),
                    });
                })
                .catch((err) => errorNotify(err, toast));
        }
    }, [toast, user]);
    const save = useCallback(() => {
        if (!user)
            return;
        dataApi.withdrawSave(user.ID, inputParams.type, inputParams.spbTel, inputParams.spbTelBankId ? parseInt(inputParams.spbTelBankId) : -1,
            inputParams.cardNumber, inputParams.accountNumber, inputParams.bic)
            .then((o) => {
                if (o) {
                    toast({title: "Save", status: "success"})
                    // setInputParams(inputDefault);
                } else {
                    toast({title: "Save failed", status: "error"});
                }
            })
            .catch((err) => errorNotify(err, toast));
    }, [user, inputParams, toast]);

    return (
        <Center>
            <Stack>
                <Field.Root orientation="horizontal" required>
                    <Field.Label>Тип вывода <Field.RequiredIndicator/></Field.Label>
                    <Select.Root
                        value={[String(inputParams.type)]}
                        // defaultValue={[String(inputParams.type)]}
                        collection={withdrawTypeList}
                        onValueChange={(e: any) => setInputParams(prev => {
                            return {
                                ...prev, type: e.value[0]
                            }
                        })}>
                        <Select.HiddenSelect/>
                        <Select.Control>
                            <Select.Trigger>
                                <Select.ValueText placeholder="Тип вывода"/>
                            </Select.Trigger>
                            <Select.IndicatorGroup>
                                <Select.Indicator/>
                            </Select.IndicatorGroup>
                        </Select.Control>
                        <Select.Positioner>
                            <Select.Content>
                                {withdrawTypeList.items.map((it: any) => (
                                    <Select.Item item={it} key={it.value}>
                                        {it.label}
                                        <Select.ItemIndicator/>
                                    </Select.Item>
                                ))}
                            </Select.Content>
                        </Select.Positioner>
                    </Select.Root>
                </Field.Root>
                <Show when={inputParams.type === "TEL"}>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Телефон <Field.RequiredIndicator/></Field.Label>
                        <Input type="tel" placeholder="Телефон"
                               value={inputParams.spbTel}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, spbTel: it.target.value}
                               })}/>
                    </Field.Root>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Банк <Field.RequiredIndicator/></Field.Label>
                        <Input type="text" placeholder="Банк"
                               value={inputParams.spbTelBankId}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, spbTelBankId: it.target.value}
                               })}/>
                    </Field.Root>
                </Show>
                <Show when={inputParams.type === "CARD"}>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Номер карты <Field.RequiredIndicator/></Field.Label>
                        <Input type="text" placeholder="Номер карты"
                               value={inputParams.cardNumber}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, cardNumber: it.target.value}
                               })}/>
                    </Field.Root>
                </Show>
                <Show when={inputParams.type === "ACC"}>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Банковский счет <Field.RequiredIndicator/></Field.Label>
                        <Input type="text" placeholder="Банковский счет"
                               value={inputParams.accountNumber}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, accountNumber: it.target.value}
                               })}/>
                    </Field.Root>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>БИК <Field.RequiredIndicator/></Field.Label>
                        <Input type="text" placeholder="БИК"
                               value={inputParams.bic}
                               onChange={(it) => setInputParams((prevState) => {
                                   return {...prevState, bic: it.target.value}
                               })}/>
                    </Field.Root>
                </Show>
                <Button borderRadius={0} variant="solid" colorScheme="teal" width="full" onClick={save}>
                    Сохранить
                </Button>
            </Stack>
        </Center>
    );
};